import styled from 'styled-components'
import { color } from 'utils'

const Separator = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid ${color('dark700')};
  margin-top: 0.75rem;
`

export default Separator
